import axios from 'axios'
import Vue from 'vue'


export default class MotivateCloudApi {
  constructor(token) {
    this.client = axios.create({
      baseURL: process.env.VUE_APP_CLOUD_API,
      timeout: 10000,
      headers: {
        Authorization: 'Bearer ' + token
      }
    });
    setInterval(() => {
      this._updateToken()
    }, 100000)
  }

  getCloudApi() {
    return this.client
  }

  _updateToken() {
     this.client.defaults.headers.Authorization = 'Bearer ' + Vue.prototype.$auth.getOauthToken()
  }
}


